(function () {
  "use strict";

  const INLINE_BTN_ID = "leagueAddLeagueInlineBtn";
  const MOBILE_BTN_ID = "mobileAddLeagueBtn";
  const MODAL_OPEN_CLASS = "plp-league-modal-open";

  let mountNode = null;
  let loadingProfiles = null;

  function uniq(values) {
    return Array.from(new Set((values || []).map((value) => String(value || "").trim()).filter(Boolean)));
  }

  async function fetchProfiles() {
    if (loadingProfiles) return loadingProfiles;

    loadingProfiles = fetch("/a/app?app=get-claimed-profiles", { method: "GET" })
      .then((response) => {
        if (!response.ok) throw new Error(`Failed to load profiles (${response.status})`);
        return response.json();
      })
      .then((payload) => {
        const profiles = Array.isArray(payload?.profiles) ? payload.profiles : [];
        return {
          profiles: profiles.map((profile) => ({
            id: profile.id,
            title: profile.title || profile.slug || "",
            slug: profile.slug || "",
            locationState: profile.locationState || "",
            locationCity: profile.locationCity || "",
          })),
          isGlobalCustomer: Boolean(payload?.isGlobalCustomer),
        };
      })
      .finally(() => {
        loadingProfiles = null;
      });

    return loadingProfiles;
  }

  function ensureMountNode() {
    if (mountNode) return mountNode;
    mountNode = document.createElement("div");
    mountNode.className = "league-modal-root";
    document.body.classList.add(MODAL_OPEN_CLASS);
    document.body.appendChild(mountNode);
    return mountNode;
  }

  function unmountModal() {
    document.body.classList.remove(MODAL_OPEN_CLASS);
    if (!mountNode) return;
    if (window.preact && typeof window.preact.render === "function") {
      window.preact.render(null, mountNode);
    }
    mountNode.remove();
    mountNode = null;
  }

  async function openLeagueModal(fallbackHref) {
    if (!window.isCustomerLoggedIn || typeof window.renderFrontendLeagueForm !== "function") {
      window.location.href = fallbackHref;
      return;
    }

    const profilePayload = await fetchProfiles();
    const profiles = Array.isArray(profilePayload?.profiles) ? profilePayload.profiles : [];
    if (!profiles.length) {
      window.location.href = fallbackHref;
      return;
    }

    const stateOptions = uniq(profiles.map((profile) => profile.locationState));

    const node = ensureMountNode();
    window.renderFrontendLeagueForm(node, {
      isOpen: true,
      allProfiles: profiles,
      locationStateOptions: stateOptions,
      isGlobalCustomer: Boolean(profilePayload?.isGlobalCustomer),
      onClose: () => {
        unmountModal();
      },
      onSubmit: () => {
        window.location.reload();
      },
    });
  }

  function wireButton(button) {
    if (!button) return;
    button.addEventListener("click", (event) => {
      event.preventDefault();
      const href = button.getAttribute("href") || "/pages/add-league";
      openLeagueModal(href);
    });
  }

  function init() {
    wireButton(document.getElementById(INLINE_BTN_ID));
    wireButton(document.getElementById(MOBILE_BTN_ID));
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
